import useCurrentMember from '@/member/hooks/useCurrentMember'
import useOrgMember from '@/member/hooks/useOrgMember'
import { useOrgContext } from '@/org/contexts/OrgContext'
import { CircleFragment, Visibility_Enum } from '@gql'
import { getVisibilityAccess } from '@rolebase/shared/model/visibility'
import { useMemo } from 'react'

// The roles and circles a tension or a project may be carried by (#121, Q10):
// those of the circles where the member holds a role, their sub-circles and
// links included. It is the Circle level of the Hasura insert check (participant
// of the circle, or reader of it). It is the "My perimeter" level of the circle
// filter, and what creation forms leave selectable. `currentId` is always kept.
// A creation form passes its chosen visibility: in Role visibility the server
// only accepts the member's own roles (no reader branch).
export default function useWritableCircles(
  currentId?: string,
  visibility: Visibility_Enum = Visibility_Enum.Circle
): CircleFragment[] {
  const { orgData } = useOrgContext()
  const currentMember = useCurrentMember()
  const isOrgWriter = useOrgMember()

  return useMemo(() => {
    if (!orgData) return []
    return orgData.circles.filter(
      (circle) =>
        circle.id === currentId ||
        getVisibilityAccess({
          orgData,
          circleId: circle.id,
          visibility,
          memberId: currentMember?.id,
          isOrgWriter,
        }).canWrite
    )
  }, [orgData, currentMember, isOrgWriter, currentId, visibility])
}
